import Icon from '../components/Icon.vue'

Icon.register({
  'hot-tub': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M414.2 177.6c-3.2-25.4-14.6-48-32-62.1-27.7-22.6-45.8-58-50.1-97.2-1.1-9.8 6.5-18.3 16-18.3h16.1c8 0 14.7 6.1 15.7 14.3 3.2 25.4 14.6 48 32 62.2 27.7 22.6 45.8 58 50.1 97.2 1.1 9.8-6.5 18.3-16 18.3h-16.1c-8 0-14.7-6.1-15.8-14.3zM306.2 177.6c-3.2-25.4-14.6-48-32-62.1-27.7-22.6-45.8-58-50.1-97.2-1.1-9.8 6.5-18.3 16-18.3h16.1c8 0 14.7 6.1 15.7 14.3 3.2 25.4 14.6 48 32 62.2 27.7 22.6 45.8 58 50.1 97.2 1.1 9.8-6.5 18.3-16 18.3h-16.1c-8 0-14.7-6.1-15.8-14.3zM480 256c17.7 0 32 14.3 32 32v160c0 35.3-28.7 64-64 64h-384c-35.3 0-64-28.7-64-64v-224c0-35.3 28.7-64 64-64h42.7 0c11.8 0 29 5.7 38.4 12.8l110.9 83.2h224zM128 440v-112c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8zM224 440v-112c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8zM320 440v-112c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8zM416 440v-112c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8zM64 128c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hot-tub.js
// module id = 1465
// module chunks = 0